import _slicedToArray from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'next-i18next';
import { UNIT_TYPE_TRANSLATIONS } from '@spa/shared/constants/translations';
import { Wrapper, UnitType, Photo, Photos, UnitTitle, PhotosGroup } from './styles';
import { PHOTOS_MODAL_SECTIONS } from '@spa/offer/constants/modals';
import { showModalAction } from '@spa/shared/store/actions/modal';
import { modalIds } from '@spa/offer/components/Modals/modal-displayer';
import Placeholder from '@spa/shared/components/Unisystem/Placeholder';
var GallerySection = function GallerySection(_ref) {
  var photos = _ref.photos,
    photosGrid = _ref.photosGrid,
    showCarousel = _ref.showCarousel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return __jsx(Wrapper, null, Object.keys(photosGrid || {}).map(function (unitTypeKey) {
    var _unitTypeKey$split = unitTypeKey.split(':'),
      _unitTypeKey$split2 = _slicedToArray(_unitTypeKey$split, 2),
      unitType = _unitTypeKey$split2[0],
      unitIndex = _unitTypeKey$split2[1];
    var translatedType = t(UNIT_TYPE_TRANSLATIONS[unitType]);
    var label = "".concat(translatedType, " ").concat(unitIndex !== null && unitIndex !== void 0 ? unitIndex : '').trim();
    var groups = photosGrid[unitTypeKey];
    return __jsx(UnitType, {
      key: unitTypeKey,
      id: label
    }, __jsx(UnitTitle, null, label), __jsx(Photos, null, groups.map(function (_ref2, index) {
      var group_type = _ref2.group_type,
        photosGroup = _ref2.photos;
      return __jsx(PhotosGroup, {
        key: "".concat(group_type, "-").concat(index),
        className: group_type
      }, photosGroup.map(function (_ref3) {
        var id = _ref3.id,
          href = _ref3.href,
          isPlaceholder = _ref3.isPlaceholder;
        return href && !isPlaceholder ? __jsx(Photo, {
          key: id,
          src: href,
          alt: label,
          onClick: function onClick() {
            return showCarousel(id, photos);
          }
        }) : __jsx(Placeholder, {
          key: id,
          type: unitType,
          title: t('No photo yet')
          // eslint-disable-next-line prettier/prettier
          ,
          subtitle: t('but we\'re working on it!'),
          onClick: function onClick() {
            return showCarousel();
          }
        });
      }));
    })));
  }));
};
var mapStateToProps = function mapStateToProps(_ref4) {
  var _ref4$offer$photosMod = _ref4.offer.photosModal,
    photos = _ref4$offer$photosMod.photos,
    photosGrid = _ref4$offer$photosMod.photosGrid;
  return {
    photos: Array.isArray(photos) ? photos.filter(function (photo) {
      return !!(photo !== null && photo !== void 0 && photo.href);
    }) : [],
    photosGrid: photosGrid
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showCarousel: function showCarousel(selectedPhotoId, photos) {
      dispatch(showModalAction({
        modalId: modalIds.PHOTOS_MODAL,
        section: PHOTOS_MODAL_SECTIONS.carousel.label,
        selectedPhotoIndex: selectedPhotoId ? photos.findIndex(function (_ref5) {
          var id = _ref5.id;
          return id === selectedPhotoId;
        }) : 0
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(GallerySection);